import {
  PDP_CAROUSEL_HEADINGS,
  PDP_PRODUCTVIEWBUTTON_TEXTS,
} from "arv-extends/constants";

const PDP_COMPONENTS = {
  PINCODE_BLOCK_TITLE: "DELIVERY / STORE OPTIONS:",
  ENTER_PINCODE_TEXT: "Enter your Pincode",
  ACCORDION_TEXT_FEATURES: "FEATURES",
};

// Overrides Constants
PDP_CAROUSEL_HEADINGS.IN_THIS_LOOK = "COMPLETE THE LOOK";
PDP_PRODUCTVIEWBUTTON_TEXTS.shop = "BUY NOW";
PDP_PRODUCTVIEWBUTTON_TEXTS.newText = "New";

const PDP_RETURNS = {
  returnPolicy:
    'How to return this item? Ship it back to us or have us pick it up within 15 days. Just keep it unwashed, undamaged and with tags intact so it passes our quality checks. See <a class="nw-pdp-desktopaccordiontnc" href="/customercare" target="_blank">FAQs</a> on our Returns Policy for more.',
  noReturnPolicy: "This item can’t be returned.",
};
const PDP_SIZE_MODAL_TITLE = "Select size to add to cart";
export { PDP_COMPONENTS, PDP_RETURNS, PDP_SIZE_MODAL_TITLE };
